module.exports = __webpack_public_path__ + "static/moss-a93990a60c624b575fca92441b88e8cd.jpg";